import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="not-found">
      <h1>404</h1>
      <p>ไม่พบหน้านี้</p>
      <Link to="/dashboard" className="btn btn-primary">กลับ Dashboard</Link>
    </main>
  );
}
